import React from 'react';
import '../css/qrDisplay.css'
import {tempIconList} from '../components/Images';
import QRCode from 'qrcode.react';

const BMSPublicQRPage = () => {
    const currentUrl = window.location.hostname;
    const qrUrl = `https://${currentUrl}/buttons-oncologia`
    return (
        <div className="qr-content">
            <div className="qr-content-container">
                
            <h1 className="qr-content-text">Vamos <span className="text-color">Contigo</span></h1>
                <h2 className="qr-content-text">Programa Soporte a <span className="text-color">Pacientes</span></h2>
                
                <div className="qr-content-desc">
                    <div className="qr-content-icon">
                        <img src={tempIconList} alt="" className="icon"/>
                    </div>
                    <div className="qr-content-desc-text">    
                        Programa especialmente diseñado pensando en pacientes  <span class="text-color">diagnosticados con patologías oncológicas específicas.</span>
                    </div>
                </div>
                <div class="qr-display-image">
                    <QRCode                            
                        id="bmsQE"
                        value={qrUrl}
                        level={"H"}
                        size={300}
                        includeMargin={true}
                    />                    
                </div>
                
            </div>
            <div className="qr-footer">
            <div className="qr-footer-content">
                Material de uso exclusivo para pacientes
            </div>
        </div>
        </div>
    );
}

export default BMSPublicQRPage;
